module.exports = "/_next/static/images/Check@2x-7f5dbd4b9fabe6ae1d3cca5dcf5a569c.png";